import store from "../../../../../../store";
import {getCurrentLayout} from "../../../../../appLayout";
import {ALLOWED_LABEL_NAV_ITEMS, BACKSPLASH_LABELS, COUNTERTOP_LABELS, EDGE_LABELS} from "../../../../constants";
import {IS_LIXIL_UI} from "../../../../../../config";
import {SHAPE_HARDCODED_PART_IDS} from "../../../../constantsFeature";

/**
 * is used for category switching available partIds
 * @param {string} partId default part id used for shape type
 * @return {string} final partId
 */
export const checkShapeForAvailablePartId = (partId) => {
  const {fabricatorState, qtState, sqftState, wizardState} = store.getState();
  const layout = getCurrentLayout();
  const wizardIsActive = wizardState.wizardIsActive;

  if (SHAPE_HARDCODED_PART_IDS.includes(partId)) {
    return partId
  }

  if (IS_LIXIL_UI || !layout.qtCategories && document.kvConfig.visualizerType === "Fireplace") {
    // lixil-1) if we opened feature from QuotingTool - try to assign this partId
    if (sqftState.sqftFromFeature && sqftState.sqftFromFeature.cartFeature
      && !Object.keys(BACKSPLASH_LABELS).includes(sqftState.sqftFromFeature.cartFeature.partId)
      && !Object.keys(EDGE_LABELS).includes(sqftState.sqftFromFeature.cartFeature.partId)
      && Object.keys(ALLOWED_LABEL_NAV_ITEMS).includes(sqftState.sqftFromFeature.cartFeature.partId)
    ) {
      return sqftState.sqftFromFeature.cartFeature.partId
    }
  }

  if (wizardIsActive) {
    if (sqftState.sqftFromFeature && sqftState.sqftFromFeature.cartFeature
      && Object.keys(COUNTERTOP_LABELS).includes(sqftState.sqftFromFeature.cartFeature.partId)
    ) {
      return sqftState.sqftFromFeature.cartFeature.partId
    }
    return partId
  }

  if ((!fabricatorState.settings.useCategorySwitching || !layout.qtCategories || !qtState.qtActiveCategory)) {
    return partId
  }

  const currentCategory = layout.qtCategories.find(qtCat => qtCat.name === qtState.qtActiveCategory);
  if (!currentCategory || !currentCategory.subParts) {
    return partId
  }

  // 1) if we opened feature from QuotingTool - try to assign this partId
  if (sqftState.sqftFromFeature && sqftState.sqftFromFeature.cartFeature
    && currentCategory.subParts.some(subPart => subPart.part.partId === sqftState.sqftFromFeature.cartFeature.partId)
    && !Object.keys(BACKSPLASH_LABELS).includes(sqftState.sqftFromFeature.cartFeature.partId)
    && !Object.keys(EDGE_LABELS).includes(sqftState.sqftFromFeature.cartFeature.partId)
    && Object.keys(ALLOWED_LABEL_NAV_ITEMS).includes(sqftState.sqftFromFeature.cartFeature.partId)
  ) {
    return sqftState.sqftFromFeature.cartFeature.partId
  }

  // 2) check for center island feature group
  const isCountertop = partId === "countertop" || partId === "center_island_countertop";
  if (isCountertop) {
    const countertopNavItem = currentCategory.subParts.find(subPart => {
      return subPart.part.partId.includes(partId)
    });

    if (countertopNavItem) {
      return countertopNavItem.part.partId
    }
  }

  // 3) check for existing navItem
  const existingPartId = currentCategory.subParts.some(subPart => {
    return subPart.part.partId === partId
  });
  if (existingPartId) {
    return partId
  }

  // 4) here we replace default partId with existing in category partId
  for (let i = 0; i < currentCategory.subParts.length; i++) {
    if (ALLOWED_LABEL_NAV_ITEMS[currentCategory.subParts[i].part.partId]) {
      return currentCategory.subParts[i].part.partId
    }
  }

  // 5) if nothing found - let it be at least default shape's partId
  return partId
}
